import { render, staticRenderFns } from "./share-detail-table.vue?vue&type=template&id=701b3136&"
import script from "./share-detail-table.vue?vue&type=script&lang=js&"
export * from "./share-detail-table.vue?vue&type=script&lang=js&"
import style0 from "./share-detail-table.vue?vue&type=style&index=0&id=701b3136&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports